import React from 'react';

import { Typography } from '@lyearn/ui';
import { useHeroContext } from '@/modules/corporate/components/DetailPageComponents/DetailHero/context';

const Title: React.FC<Partial<React.ComponentProps<typeof Typography>>> = (props) => {
  const {
    content: { title },
  } = useHeroContext();
  const titleVariant = title && title.length > 60 ? 'display-s' : 'display-xl';

  if (!title) {
    return null;
  }

  return (
    <Typography as="h1" color="text-text-primary" variant={titleVariant} {...props}>
      {title}
    </Typography>
  );
};

export default Title;
